import { render, staticRenderFns } from "./scrollList.vue?vue&type=template&id=61058946&scoped=true&"
import script from "./scrollList.vue?vue&type=script&lang=js&"
export * from "./scrollList.vue?vue&type=script&lang=js&"
import style0 from "./scrollList.vue?vue&type=style&index=0&id=61058946&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61058946",
  null
  
)

export default component.exports